import { Endpoint } from '../endpoint';
import { SupportTicketStatusResponse, SupportTicketStatusId } from '@business/entities/support_ticket_status';

export function fetchSupportTicketStatuses() {
  return Endpoint.get<SupportTicketStatusResponse[]>(`@gc/support-ticket-status`);
}

export function fetchSupportTicketStatus(id: SupportTicketStatusId) {
  return Endpoint.get<SupportTicketStatusResponse>(`@gc/support-ticket-status/${id}`);
}

export function updateSupportTicketStatus(id: SupportTicketStatusId, data: Partial<SupportTicketStatusResponse>) {
  return Endpoint.patch<SupportTicketStatusResponse[]>(`@gc/support-ticket-status/${id}`, { data });
}

export function createSupportTicketStatus(data: Partial<SupportTicketStatusResponse>) {
  return Endpoint.post<SupportTicketStatusResponse[]>(`@gc/support-ticket-status`, { data });
}

export function deleteSupportTicketStatus(id: SupportTicketStatusId) {
  return Endpoint.delete<void>(`@gc/support-ticket-status/${id}`);
}

export function sortSupportTicketStatus(ids: string[]) {
  return Endpoint.post<SupportTicketStatusResponse[]>(`@gc/support-ticket-status/sort-support-ticket-status`, { data: { ids } });
}
